import { ContactAttributes } from 'lib/common/constants/contactAttributes';

import { ATTACHED_DATA_BLOCK_TYPES } from '../../constants/attachedDataBlockTypes';

export const attachedDataMap = {
  [ContactAttributes.INTENTS]: {
    type: ATTACHED_DATA_BLOCK_TYPES.BADGE_LIST,
    label: 'Intents',
  },
  [ContactAttributes.TRANSCRIPT]: {
    type: ATTACHED_DATA_BLOCK_TYPES.ACCORDION,
    label: 'Transcript',
  },
  [ContactAttributes.PHONE_NUMBER]: {
    type: ATTACHED_DATA_BLOCK_TYPES.PHONE_NUMBER,
    label: 'Phone Number',
  },
  [ContactAttributes.OUTBOUND_CAMPAIGN]: {
    type: ATTACHED_DATA_BLOCK_TYPES.DYNAMIC,
    label: 'Outbound Campaign',
  },
  [ContactAttributes.OUTBOUND_CAMPAIGN_DESCRIPTION]: {
    type: ATTACHED_DATA_BLOCK_TYPES.DYNAMIC,
    label: 'Outbound Campaign Description',
  },
};

